import React, { Component } from 'react';

export default class PasswordValidate extends Component {

	render(){
		return (
			<div>
				<div className='row form-group'>
					<div className='col-12'>
						<h4>Password Validate</h4>
					</div>
				</div>
			</div>
		)
	}
}


// WEBPACK FOOTER //
// ./src/components/manage_users/settings/PasswordValidate.js